import React from 'react';
import { 
  Box, 
  Typography, 
  Card, 
  Grid,
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Divider
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  Assignment,
  FlightTakeoff,
  Build,
  ChevronRight
} from '@mui/icons-material';

const NavigationItem = ({ title, description, icon, path }) => {
  const navigate = useNavigate();
  
  return (
    <ListItemButton 
      onClick={() => navigate(path)}
      sx={{ 
        py: 2,
        px: 2,
        '&:hover': {
          backgroundColor: 'rgba(53, 152, 183, 0.08)',
        }
      }}
    >
      <ListItemIcon sx={{ color: '#3598b7', minWidth: 40 }}>
        {icon}
      </ListItemIcon>
      <ListItemText 
        primary={title}
        secondary={description}
        primaryTypographyProps={{
          sx: { color: '#2e2e2e', fontWeight: 500 }
        }}
        secondaryTypographyProps={{
          sx: { color: 'rgba(46, 46, 46, 0.7)' }
        }}
      />
      <ChevronRight sx={{ color: '#3598b7' }} />
    </ListItemButton>
  );
};

const Pilot = () => {
  const sections = [
    {
      title: "Planlegg Oppdrag",
      description: "Sjekklister og skjemaer for planlegging av oppdrag",
      icon: <Assignment />,
      path: "/pilot/plan"
    },
    {
      title: "På Lokasjon",
      description: "Sjekklister for DJI Inspire 2/3 og Freefly Alta X",
      icon: <FlightTakeoff />,
      path: "/pilot/location"
    },
    {
      title: "Flyoperasjoner",
      description: "Flyprosedyrer og sikkerhetsprotokoll",
      icon: <FlightTakeoff />,
      path: "/pilot/operations"
    },
    {
      title: "Etter Flyging & Feilsøking",
      description: "Fullføring av oppdrag og problemløsning",
      icon: <Build />,
      path: "/pilot/post"
    }
  ];

  return (
    <Box sx={{ 
      width: '100%'
    }}>
      <Typography variant="h4" sx={{ mb: 3, color: '#3598b7', fontWeight: 600 }}>
        Pilot Ressurser
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card sx={{ 
            backgroundColor: '#ffffff', 
            borderRadius: 0,
            boxShadow: 'none',
            border: '1px solid rgba(0, 0, 0, 0.12)',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <Box sx={{ p: 2, borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
              <Typography variant="h6" sx={{ color: '#3598b7', fontWeight: 600 }}>
                Navigasjon
              </Typography>
            </Box>
            <List disablePadding sx={{ flex: 1 }}>
              {sections.map((section, index) => (
                <React.Fragment key={index}>
                  <NavigationItem {...section} />
                  {index < sections.length - 1 && (
                    <Divider />
                  )}
                </React.Fragment>
              ))}
            </List>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Pilot;